module.exports = __webpack_public_path__ + "img/travel_detail_2.f1c11d2e.svg";